/* global axios */
import ApiClient from './ApiClient';

class WebCallsAPI extends ApiClient {
  constructor() {
    super('web_calls', { accountScoped: true });
  }

  create(conversationId) {
    return axios.post(this.url, { conversation_id: conversationId });
  }

  customerLink(conversationId) {
    return axios.get(`${this.url}/customer_link`, {
      params: { conversation_id: conversationId },
    });
  }

  createCustomerLink({ inboxId, name, phoneNumber }) {
    return axios.post(`${this.url}/customer_links`, {
      inbox_id: inboxId,
      name,
      phone_number: phoneNumber,
    });
  }

  accept(id, clientId) {
    return axios.post(`${this.url}/${id}/accept`, { client_id: clientId });
  }

  reject(id) {
    return axios.post(`${this.url}/${id}/reject`);
  }

  terminate(id, durationSeconds) {
    return axios.post(`${this.url}/${id}/terminate`, {
      duration_seconds: durationSeconds,
    });
  }

  uploadRecording(id, blob, filename) {
    const formData = new FormData();
    formData.append('recording', blob, filename);
    return axios.post(`${this.url}/${id}/recording`, formData);
  }
}

export default new WebCallsAPI();
